import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { TaskList } from "@src/components/modules/resource-planning/tasks/listing";
import { NavigationTasks } from "@src/components/widgets/AppSubNav/NavigationTasks/NavigationTasks";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    fullWidth
    noGutters
    noTopMargin
    noBottomMargin
    title={t`Starred tasks`}
    navigation={<NavigationTasks variant="page" />}
  >
    <DemoModule module={Modules.Projects}>
      <TaskList variant="starred" />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/tasks/starred/")({
  component: Page,
});
